import { startTestBox } from '@testboxlab/browser';
import { useCallback } from 'react';
import { initSegment } from 'app/utils/segment';
import { sentrySetup } from 'app/utils/sentry';
import { featureFlags } from 'utils/featureFlagging/featureFlags';
import { birdeatsbugService } from './scripts/birdeatsbug/birdeatsbug';
import { fullviewService } from './scripts/fullview/fullview';
import { olvyService } from './scripts/olvy/olvy';
import { userlaneService } from './scripts/userlane/userlane';
export const useThirdPartyScripts = () => {
    const init = useCallback(({ user, organization, connectionId }) => {
        const { useUserlane, useBirdeatsbug, fullviewScreenSharing, useOlvy } = featureFlags.get([
            'use-userlane',
            'use-birdeatsbug',
            'fullview-screen-sharing',
            'use-olvy',
        ]);
        initSegment({ user, organization });
        // Scripts below are loaded only in Production.
        if (!PRODUCTION)
            return;
        sentrySetup({ user, organization, connectionId });
        if (useUserlane) {
            userlaneService.install();
            userlaneService.loadUser(user, organization);
            userlaneService.initialize();
        }
        if (useBirdeatsbug) {
            birdeatsbugService.start();
            birdeatsbugService.loadUser(user);
        }
        if (fullviewScreenSharing) {
            fullviewService.start();
            fullviewService.loadUser(user, organization);
        }
        if (useOlvy) {
            olvyService.load(user, organization);
        }
        if (organization.subdomain.startsWith('tbx-')) {
            try {
                startTestBox({});
            }
            catch (error) {
                console.error('TestBox threw an error: ', error);
            }
        }
    }, []);
    return init;
};
